module.exports = __webpack_public_path__ + "img/bf61c83904b47a33b5942c9d673571b6.png";